import { render, staticRenderFns } from "./ProductQuantityDiscount.vue?vue&type=template&id=0caef31d"
import script from "./ProductQuantityDiscount.vue?vue&type=script&lang=js"
export * from "./ProductQuantityDiscount.vue?vue&type=script&lang=js"
import style0 from "./ProductQuantityDiscount.vue?vue&type=style&index=0&id=0caef31d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports